import { trimSlashes } from '../utils';

// Construct mapi request with or without messages
export const getMapiUrl = (params) => {
    const
        {
            mapiHost,
            userMail
        } = params;

    return `//${trimSlashes(mapiHost)}/mailbox/${userMail}/folders/INBOX`;
};
